import React, { useContext, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./AdminEditPagamento.css";
import { Button, Input } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import axios from "axios";
import question_icon from "../../../../assets/images/question.png";

const normalizarSerial = (valor) => {
  if (valor === null || valor === undefined) return "";
  const texto = String(valor).trim();
  return texto.toLowerCase() === "null" ? "" : texto;
};

const normalizarDescricaoMaquina = (descricao) => {
  const texto = String(descricao || "").trim();
  if (!texto) return texto;
  return texto.replace(/^m[aá]quina\b/i, "Máquina");
};

const AdminEditPagamento = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { maquinaInfos = {}, clienteInfo = {} } = location.state || {};
  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;
  const { id } = useParams();

  const [data, setData] = useState({
    nome: String(maquinaInfos?.nome ?? ""),
    descricao: normalizarDescricaoMaquina(maquinaInfos?.descricao),
    estoque: Number(maquinaInfos?.estoque ?? 0),
    store_id: maquinaInfos?.store_id ?? "",
    maquininha_serial: normalizarSerial(maquinaInfos?.maquininha_serial),
    valorDoPulso: maquinaInfos?.pulso ?? 0,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => {
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const onSave = async () => {
    const errorsTemp = {};
    const nome = String(data.nome || "").trim();
    const descricao = normalizarDescricaoMaquina(data.descricao);

    if (!nome) errorsTemp.nome = "Este campo é obrigatório";
    if (!descricao) errorsTemp.descricao = "Este campo é obrigatório";
    if (Number(data.valorDoPulso) < 0) errorsTemp.valorDoPulso = "Este campo é obrigatório";
    if (Number(data.estoque) < 0) errorsTemp.estoque = "Estoque é obrigatório";

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    const serial = normalizarSerial(data.maquininha_serial);
    const payload = {
      id,
      nome,
      descricao,
      estoque: Number(data.estoque),
      store_id: String(data.store_id ?? "").trim(),
      valorDoPulso: data.valorDoPulso,
    };

    if (serial) payload.maquininha_serial = serial;

    setIsLoading(true);
    try {
      await axios.put(`${process.env.REACT_APP_SERVIDOR}/maquina`, payload, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      });

      setNotiMessage({ type: "success", message: "Máquina atualizada com sucesso." });
      navigate(`${links.CLIENTES_MAQUINAS}/${clienteInfo.id}`, { state: clienteInfo });
    } catch (err) {
      const status = err?.response?.status;
      if ([401, 403].includes(status)) {
        setNotiMessage({
          type: "error",
          message: "A sua sessão expirou, para continuar faça login novamente.",
        });
      } else if (status === 400) {
        setNotiMessage({
          type: "error",
          message: err?.response?.data?.error || "Não foi possível salvar as alterações desta máquina.",
        });
      } else {
        setNotiMessage({ type: "error", message: "Um erro ocorreu" });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Admin_PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="Admin_PagamentosSearch_header">
        <div className="Admin_PagamentosSearch_header_left">
          <div className="Admin_Dashboard_staBlockTitle">Editar Máquina</div>
        </div>

        <Button
          className="Admin_EditPagamentos_header_back"
          onClick={() => navigate(`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${id}`, { state: location.state })}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Admin_Update_Pagamento_content">
        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="nome">Nome:</label>
          <Input
            placeholder="Máquina 1"
            value={data.nome}
            id="nome"
            type="text"
            name="nome"
            autoComplete="nome"
            onChange={(event) => handleChange("nome", event.target.value)}
            className={errors.nome ? "Admin_Update_Pagamento_inputError" : ""}
          />
          {errors.nome && <div className="Admin_Update_Pagamento_itemFieldError">{errors.nome}</div>}
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="descricao">Descrição:</label>
          <Input
            placeholder="Máquina da padaria de juquinha"
            value={data.descricao}
            id="descricao"
            type="text"
            name="descricao"
            autoComplete="descricao"
            onChange={(event) => handleChange("descricao", event.target.value)}
            className={errors.descricao ? "Admin_Update_Pagamento_inputError" : ""}
          />
          {errors.descricao && <div className="Admin_Update_Pagamento_itemFieldError">{errors.descricao}</div>}
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="store_id" style={{ display: "flex", alignItems: "center" }}>
            <span>Store_id:</span>
            <Button
              className="Admin_EditPagamentos_header_HelpPage"
              onClick={() => navigate(links.HELP_PAGE, {
                state: { ...location.state, redirect_url: `${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/${id}` },
              })}
              disabled={isLoading}
            >
              <img className="Admin_Edit_Pagamento_Icon" src={question_icon} alt="question icon" />
            </Button>
          </label>
          <Input
            placeholder="12345678"
            value={data.store_id}
            id="store_id"
            name="store_id"
            autoComplete="store_id"
            onChange={(event) => handleChange("store_id", event.target.value)}
          />
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="maquininha_serial">Maquininha_serial:</label>
          <Input
            placeholder=""
            value={data.maquininha_serial}
            id="maquininha_serial"
            name="maquininha_serial"
            autoComplete="maquininha_serial"
            onChange={(event) => handleChange("maquininha_serial", event.target.value)}
          />
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="valorDoPulso">Valor Do Pulso R$:</label>
          <Input
            placeholder="1.50"
            value={data.valorDoPulso}
            id="valorDoPulso"
            type="number"
            name="valorDoPulso"
            autoComplete="valorDoPulso"
            onChange={(event) => handleChange("valorDoPulso", event.target.value)}
            className={errors.valorDoPulso ? "Admin_Update_Pagamento_inputError" : ""}
          />
          {errors.valorDoPulso && <div className="Admin_Update_Pagamento_itemFieldError">{errors.valorDoPulso}</div>}
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label className="Admin_Update_Pagamento_itemFieldLabel" htmlFor="estoque">Estoque:</label>
          <Input
            placeholder="0"
            value={data.estoque}
            id="estoque"
            type="number"
            name="estoque"
            autoComplete="estoque"
            onChange={(event) => handleChange("estoque", event.target.value)}
            className={errors.estoque ? "Admin_Update_Pagamento_inputError" : ""}
          />
          {errors.estoque && <div className="Admin_Update_Pagamento_itemFieldError">{errors.estoque}</div>}
        </div>

        <Button className="Admin_Update_Pagamento_saveBtn" onClick={() => !isLoading && onSave()} disabled={isLoading}>
          SALVAR ALTERAÇÕES
        </Button>
        <Button
          className="Admin_Update_Pagamento_deleteBtn action-delete"
          onClick={() => navigate(`${links.CLIENTES_MAQUINAS_DELETE_FORNECEDOR}/${id}`, { state: location.state })}
          disabled={isLoading}
        >
          EXCLUIR MÁQUINA
        </Button>
      </div>
    </div>
  );
};

export default AdminEditPagamento;
